import React, { useEffect, useState } from "react";
import VisibleView from "components/hoc/VisibleView";
import { DeviceInfo, WidgetProps } from "types";
import { PSLStatusWidget, PSLUsageWidget, PLSTimelineWidget } from "./psl";
import ChartActionDropdown from "../ChartActionDropdown";
import { ChartType } from "constant/chart";
import { fetchDetailDevices } from "service/gatewayService";
const getComponent = (source: string, chart: string): React.ComponentType<any> | null => {
    if (chart === ChartType.CARD_STATUS) {
        return PSLStatusWidget;
    } else if (chart === ChartType.BAR) {
        return PSLUsageWidget;
    } else if (chart === ChartType.MULTIPLE_LINES || chart === ChartType.SINGLE_STEP_LINE) {
        return PLSTimelineWidget;
    }

    return null;
};

const PSLWidget = ({
    zoomLevel,
    panel,
    panel: { source, chart, attributes },
    dashboardId,
    gatewaysConfig,
    onDelete,
}: WidgetProps) => {
    const [deviceConfig, setDeviceConfig] = useState<DeviceInfo[]>([]);
    useEffect(() => {
        (async () => {
            const _device = await fetchDetailDevices(attributes);
            setDeviceConfig(_device);
        })();
    }, [attributes])

    const Component = getComponent(source, chart);

    return (
        <>
            {Component ? (
                <div className="position-relative h-100">
                    <ChartActionDropdown
                        panelId={panel.uuid}
                        dashboardId={dashboardId}
                        onDelete={onDelete}
                        panel={panel}
                        deviceConfig={deviceConfig}
                    />
                    <VisibleView>
                        <Component
                            zoomLevel={zoomLevel}
                            panel={panel}
                            dashboardId={dashboardId}
                            gatewaysConfig={gatewaysConfig}
                            deviceConfig={deviceConfig}
                        />
                    </VisibleView>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default PSLWidget;
